export default __webpack_public_path__ + "static/Request to Transfer Form-5f26c8de3d6c20f9031159046b1d45b4.pdf";